
import React from 'react';
import { NavbarBrand, Navbar, Nav, Container, NavItem } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import logo from "./RoundTableLogo.png";
import { Button } from 'react-bootstrap';
import { useState } from 'react';

const Navigation = props => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  function reload() {
    window.location.href="/#/browsecircles"; 
    window.location.reload();
  }

  return (
    <nav role="main">
      <ul>
        <li><NavLink exact activeClassName="current" to="/"><img src={logo} alt="RoundTable-logo" width="150" /></NavLink></li>
        <li><NavLink exact activeClassName="current" to='/'>Home</NavLink></li>
        <li><NavLink exact activeClassName="current" to='/about'>About</NavLink></li>
        <li><NavLink exact activeClassName="current" to='/walkthrough'>Walkthrough</NavLink></li>
        <li><NavLink exact activeClassName="current" to='/pricing'>Pricing</NavLink></li>
        <li><NavLink exact activeClassName="current" to='/contactus'>Contact Us</NavLink></li>
      </ul>
    </nav>

  );
}

export default Navigation;